// extracted by css-extract-rspack-plugin
module.exports =  {"root":"JobCreationQuestions__root___rJX_W","loadingSpinner":"JobCreationQuestions__loadingSpinner___Yomdx"};